import image1 from "../../assets/images/undraw_visionary_technology_re_jfp7.svg";
import image2 from "../../assets/images/undraw_programmer_re_owql.svg";
import image3 from "../../assets/images/undraw_professor_re_mj1s.svg";
import image4 from "../../assets/images/undraw_logic_re_nyb4.svg";

export const homeObjOne = {
  lightBg: false,
  imgStart: "",
  lightText: true,
  lightTopLine: true,
  topLine: "marketing agency",
  description:
    "We help business owners increase their revenue. Our Team of unique specialist can help you achieve your business goals",
  primary: true,
  lightTextDesc: true,
  headline: "lead generation specialist for online business",
  buttonLabel: "Get started",
  start: "",
  alt: "Image",
  img: image1,
};
export const homeObjTwo = {
  lightBg: true,
  imgStart: "start",
  lightText: false,
  lightTopLine: false,
  topLine: "marketing agency",
  description:
    "We help business owners increase their revenue. Our Team of unique specialist can help you achieve your business goals",
  primary: false,
  lightTextDesc: false,
  headline: "lead generation specialist for online business",
  buttonLabel: "Get started",
  start: "true",
  alt: "Image",
  img: image2,
};
export const homeObjThree = {
  lightBg: false,
  imgStart: "",
  lightText: true,
  lightTopLine: true,
  topLine: "marketing agency",
  description:
    "We help business owners increase their revenue. Our Team of unique specialist can help you achieve your business goals",
  primary: true,
  lightTextDesc: true,
  headline: "lead generation specialist for online business",
  buttonLabel: "Get started",
  start: "",
  alt: "Image",
  img: image3,
};
export const homeObjFour = {
  lightBg: false,
  imgStart: "start",
  lightText: true,
  lightTopLine: true,
  topLine: "marketing agency",
  description:
    "We help business owners increase their revenue. Our Team of unique specialist can help you achieve your business goals",
  primary: true,
  lightTextDesc: true,
  headline: "lead generation specialist for online business",
  buttonLabel: "Get started",
  start: "true",
  alt: "Image",
  img: image4,
};
